import { apiAuth, apiResponseType } from "./index";

export const getDevolutions = (
  page = 1,
  params?: {
    order_by?:
      | "client_name"
      | "name"
      | "value"
      | "devolution_status_id"
      | "created_at";
    order_direction?: "asc" | "desc";
    per_page?: number;
    client_name?: string;
    created_by_name?: string;
    devolution_status_id?: string;
  }
) => {
  let url = `devolution?page=${page}`;

  if (params?.order_by) {
    url += `&order_by=${params.order_by}`;
  }

  if (params?.order_direction) {
    url += `&order_direction=${params.order_direction}`;
  }

  if (params?.per_page) {
    url += `&per_page=${params.per_page}`;
  }

  if (params?.client_name) {
    url += `&client_name=${encodeURIComponent(params.client_name)}`;
  }

  if (params?.created_by_name) {
    url += `&created_by_name=${encodeURIComponent(params.created_by_name)}`;
  }

  if (params?.devolution_status_id) {
    url += `&devolution_status_id=${encodeURIComponent(
      params?.devolution_status_id
    )}`;
  }

  return apiAuth.get(url) as apiResponseType;
};

export const createDevolution = (data: {
  name?: string;
  value: number;
  client_id: number;
  pix_key: string;
}) => apiAuth.post("devolution/store", data) as apiResponseType;

export const updateDevolutionStatus = (
  uuid: string,
  data: {
    devolution_status_id: number;
    observation?: string;
  }
) => apiAuth.put(`devolution/${uuid}/update-status`, data) as apiResponseType;

export const deleteDevolution = (uuid: string) =>
  apiAuth.delete(`devolution/${uuid}/destroy`) as apiResponseType;

export const getShowDevolution = (uuid: string) =>
  apiAuth.get(`devolution/${uuid}/show`) as apiResponseType;

// Comprovantes da devolução (financeiro envia, vendedor baixa)
export const getDevolutionFiles = (uuid: string) =>
  apiAuth.get(`devolution/${uuid}/files`) as apiResponseType;

export const uploadDevolutionFile = (uuid: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiAuth.post(`devolution/${uuid}/files`, formData) as apiResponseType;
};

export const deleteDevolutionFile = (uuid: string, fileId: number) =>
  apiAuth.delete(`devolution/${uuid}/files/${fileId}`) as apiResponseType;

// Consulta o BTG e atualiza o status do PIX da devolução
export const syncDevolutionBtgStatus = (uuid: string) =>
  apiAuth.post(`devolution/${uuid}/sync-btg-status`) as apiResponseType;

// Etapa 1 da aprovação com PIX automático: cria a iniciação no BTG (sem mover dinheiro)
// e devolve o titular real da chave
export const preparePixDevolution = (uuid: string) =>
  apiAuth.post(`devolution/${uuid}/prepare-pix`) as apiResponseType;

// Cancela no BTG a iniciação ainda pendente
export const cancelPixDevolution = (uuid: string) =>
  apiAuth.post(`devolution/${uuid}/cancel-pix`) as apiResponseType;

// Chave PIX da última devolução do cliente (para pré-preencher uma nova)
export const getLastPixKey = (clientId: number) =>
  apiAuth.get(`devolution/last-pix-key?client_id=${clientId}`) as apiResponseType;
